import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseGroupTripNoticeJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:noticeId|groupTripId|nextCursorNoticeId|applicationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseGroupTripNoticeJson] };

function listConfig(cursor = {}) {
  const params = {};
  if (cursor.limit != null) params.limit = cursor.limit;
  if (cursor.cursorCreateTime && cursor.cursorNoticeId) {
    params.cursorCreateTime = cursor.cursorCreateTime;
    params.cursorNoticeId = cursor.cursorNoticeId;
  }
  return { ...snowflakeJson, params };
}

export const groupTripNoticeApi = {
  list: (cursor) => travelClient.get(travelEndpoints.meGroupTripNotices, listConfig(cursor)),
  getUnreadCount: () => travelClient.get(travelEndpoints.meGroupTripNoticesUnreadCount, snowflakeJson),
  markRead: (noticeId) => travelClient.post(
    travelEndpoints.meGroupTripNoticeRead(noticeId),
    {},
    snowflakeJson,
  ),
  markAllRead: () => travelClient.post(
    travelEndpoints.meGroupTripNoticesReadAll,
    {},
    snowflakeJson,
  ),
};
